<template>
  <van-dialog
      className="sameStyle-dialog"
      v-model:show="showDialog"
      :showConfirmButton="false"
      :showCancelButton="false"
      :overlay="true"
      :closeOnClickOverlay="false"
      @close="handleClose"
    >
      <slot name="title"></slot>
      <slot name="container"></slot>
      <slot name="operator"></slot>
    </van-dialog>
</template>

<script>
import Vue from 'vue'
import Component from 'vue-class-component'

@Component({
  components:{},
  props:{
    show:{
      type:Boolean,
      default:false
    }
  },
  watch:{
    show:{
      handler(val){
        this.showDialog = val
      },
      immediate:true
    }
  },
  data() {
    return {
      showDialog:false
    }
  },
  created(){
  },
  methods: {
    handleClose(){
      this.showDialog = false
      this.$emit('close')
    }
  }
})
export default class SameStyleDialog extends Vue { }

</script>

<style lang='less' scoped>
.sameStyle-dialog{
  padding:48px;
  box-sizing:border-box;
  /deep/ .van-dialog__footer{
    display:none;
  }
}
</style>